export function makeApiKeyHeader(apiKey: string) {
  return {
    authorization: `Api-Key ${apiKey}`,
  };
}
